var React = require('react');

function Sipka (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"sipka"),React.createElement("g",{"id":"b903223f-909c-428c-8331-3b72c832bec8","data-name":"Layer 2","key":1},React.createElement("g",{"id":"a1f5e80f-df5a-432f-ad9a-0ef827a210f3","data-name":"ikonky"},React.createElement("path",{"id":"b20b9a72-d271-4e35-aba1-fa6b8aef15a4","data-name":"sipka","d":"M20,0,15,18.33l-6.77-6,6.5-6.86L6,11.46,0,10ZM7.78,13.89V20l2.44-3.69Z"})))]);
}

Sipka.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = Sipka;

Sipka.default = Sipka;
